import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, Button, notification } from 'antd';
import MicrophoneStream from 'microphone-stream';
import { EventStreamMarshaller } from '@aws-sdk/eventstream-marshaller';
import { fromUtf8, toUtf8 } from '@aws-sdk/util-utf8-node';
import axios from 'axios';
import { smartEmrRecordingService, speechService } from '../../utils/rxjs-sharing';
import { DATA_TRANSCRIBE, DATA_SUMMARIZE, PROCESS_AND_STORE_SMART_EMR, SMART_EMR_AUDIO_UPLOAD, LOADER, LOADER_RED } from '../../utils/constant';
import LS_SERVICE from '../../utils/localStorage';
import API_SERVICE from '../../utils/apiService';
import { v4 as uuidv4 } from 'uuid';

const eventStreamMarshaller = new EventStreamMarshaller(toUtf8, fromUtf8);

class SmartEmrRecorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smartemrmodal: false,
      smartemrMinimized: false,
      isRecording: false,
      isHeld: false,
      isSummarizing: false,
      recordingDone: false,
      recordingSeconds: 0,
      text: '',
      smartemrrawdata: '',
      currentPartial: '',
      final_raw_result: [],
      correction_terms: [],
      smartemr_field_disabled: false,
      smartemr_loader: false,
      patientInfo: null,
      navBlockVisible: false,
    };
    this.waveformCanvasRef = null;
    this.micStream = null;
    this.socket = null;
    this.audioContext = null;
    this.analyser = null;
    this.waveformAnimationId = null;
    this.browserRecognizer = null;
    this._fakeWaveformInterval = null;
    this.unblockNavigation = null;
    this.pendingLocation = null;
    // Audio recording (MediaRecorder) — captures raw audio to save/playback
    this.mediaRecorder = null;
    this.mediaStream = null;
    this.audioChunks = [];
    this.recordedBlob = null;
  }

  // ==================== AUDIO RECORDING (MediaRecorder) ====================
  startAudioRecording = async () => {
    try {
      // Reuse an existing stream if one is already open, else request mic
      if (!this.mediaStream) {
        this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      }
      this.audioChunks = [];
      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : (MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '');
      this.mediaRecorder = new MediaRecorder(this.mediaStream, mimeType ? { mimeType } : undefined);
      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) this.audioChunks.push(e.data);
      };
      this.mediaRecorder.start(1000); // collect in 1s chunks
    } catch (err) {
      console.error('Audio recording could not start:', err);
    }
  }

  pauseAudioRecording = () => {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.pause();
    }
  }

  resumeAudioRecording = () => {
    if (this.mediaRecorder && this.mediaRecorder.state === 'paused') {
      this.mediaRecorder.resume();
    } else if (!this.mediaRecorder || this.mediaRecorder.state === 'inactive') {
      // Recorder was fully stopped (e.g. after a hard stop) — start fresh
      this.startAudioRecording();
    }
  }

  // Stops the recorder and resolves with the assembled Blob
  stopAudioRecording = () => {
    return new Promise((resolve) => {
      if (!this.mediaRecorder || this.mediaRecorder.state === 'inactive') {
        const blob = this.audioChunks.length ? new Blob(this.audioChunks, { type: this.audioChunks[0].type }) : null;
        this.recordedBlob = blob;
        this._releaseMediaStream();
        resolve(blob);
        return;
      }
      this.mediaRecorder.onstop = () => {
        const blob = this.audioChunks.length ? new Blob(this.audioChunks, { type: this.audioChunks[0].type }) : null;
        this.recordedBlob = blob;
        this._releaseMediaStream();
        resolve(blob);
      };
      this.mediaRecorder.stop();
    });
  }

  _releaseMediaStream = () => {
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(t => t.stop());
      this.mediaStream = null;
    }
    this.mediaRecorder = null;
  }

  componentDidMount() {
    this.subscription = smartEmrRecordingService.status().subscribe(data => {
      // Open and start recording immediately
      if (data.openRequested) {
        // Generate a unique client reference for this recording session
        this.clientRef = uuidv4();
        this.setState({
          smartemrmodal: false,
          smartemrMinimized: false,
          text: '',
          smartemrrawdata: '',
          final_raw_result: [],
          isRecording: false,
          isSummarizing: false,
          recordingDone: false,
          isHeld: false,
          recordingSeconds: 0,
          patientInfo: data.patientInfo || null,
        }, () => {
          smartEmrRecordingService.update({ ...smartEmrRecordingService.getValue(), openRequested: false });
          this.startStreaming();
        });
      }
      // Sync timer from global
      if (data.recordingSeconds !== this.state.recordingSeconds) {
        this.setState({ recordingSeconds: data.recordingSeconds });
      }
      // Show block popup when triggered externally (e.g. header links)
      if (data.showBlockPopup && data.showBlockPopup !== this._lastBlockPopup) {
        this._lastBlockPopup = data.showBlockPopup;
        this.setState({ navBlockVisible: true });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.unblockNavigation) { this.unblockNavigation(); this.unblockNavigation = null; }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isRecording !== this.state.isRecording ||
      prevState.isHeld !== this.state.isHeld ||
      prevState.isSummarizing !== this.state.isSummarizing
    ) {
      smartEmrRecordingService.update({
        isRecording: this.state.isRecording,
        isHeld: this.state.isHeld,
        isSummarizing: this.state.isSummarizing,
      });
    }

    // Manage navigation blocking
    const isActive = this.state.isRecording || this.state.isHeld || this.state.isSummarizing;
    const wasActive = prevState.isRecording || prevState.isHeld || prevState.isSummarizing;

    if (isActive && !this.unblockNavigation) {
      this.unblockNavigation = this.props.history.block((location) => {
        if (location.pathname.startsWith('/patient/')) {
          return undefined; // allow only /patient/* routes
        }
        this.pendingLocation = location;
        this.setState({ navBlockVisible: true });
        return false; // block everything else
      });
    } else if (!isActive && this.unblockNavigation) {
      this.unblockNavigation();
      this.unblockNavigation = null;
    }
  }

  getSmartEmrVoiceMethod = () => {
    // const hospitalDetails = LS_SERVICE.get('hospital_details') || {};
    // return hospitalDetails.smartemr_voice_to_text_method || 'browser';
    // Smart EMR always uses AWS Transcribe
    return 'aws';
  }

  // ==================== START ====================
  startStreaming = async (isResume = false) => {
    // Manage raw audio capture for save/playback
    if (isResume) {
      this.resumeAudioRecording();
    } else {
      await this.startAudioRecording();
    }
    const method = this.getSmartEmrVoiceMethod();
    switch (method) {
      case 'aws': await this.startAwsStreaming(); break;
      case 'azure': this.startAzureRecording(); break;
      case 'browser': default: this.startBrowserRecording(); break;
    }
  }

  // ==================== AWS ====================
  startAwsStreaming = async () => {
    try {
      const response = await axios.post(DATA_TRANSCRIBE, { staff_id: LS_SERVICE.get("staff_id") });
      const { url, correction_terms } = response.data;
      this.setState({ correction_terms: correction_terms || [] });

      this.socket = new WebSocket(url);
      this.socket.binaryType = "arraybuffer";

      this.socket.onopen = () => {
        this.setState({ isRecording: true, isHeld: false }, async () => {
          await this.setupMic();
          this.startWaveform();
        });
      };

      this.socket.onmessage = async (message) => {
        try {
          const messageBuffer = Buffer.from(message.data);
          const unmarshalledMessage = eventStreamMarshaller.unmarshall(messageBuffer);
          const payloadText = toUtf8(unmarshalledMessage.body);
          const data = JSON.parse(payloadText);

          if (data.Transcript?.Results?.length > 0) {
            const result = data.Transcript.Results[0];
            const transcript = result.Alternatives[0].Transcript;
            if (result.IsPartial) {
              this.setState({ currentPartial: transcript, text: this.state.smartemrrawdata + " " + transcript });
            } else {
              const corrected = await this.textCorrection(transcript, this.state.correction_terms);
              const final_raw_result = [...this.state.final_raw_result, corrected];
              const newFinal = (this.state.smartemrrawdata + " " + corrected).trim();
              this.setState({ text: newFinal, smartemrrawdata: newFinal, final_raw_result, currentPartial: "" });
            }
          }
        } catch (err) { /* ignore keep-alive */ }
      };

      this.socket.onerror = (err) => console.error("WebSocket Error:", err);
    } catch (error) {
      console.error("Error starting stream:", error);
    }
  }

  setupMic = async () => {
    this.micStream = new MicrophoneStream();
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: { channelCount: 1, sampleRate: 16000, echoCancellation: false, noiseSuppression: false, autoGainControl: false }
    });
    this.micStream.setStream(stream);
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 1024;
    const source = this.audioContext.createMediaStreamSource(stream);
    source.connect(this.analyser);

    this.micStream.on('data', (chunk) => {
      const raw = MicrophoneStream.toRaw(chunk);
      const pcmBuffer = this.downsampleAndEncode(raw);
      if (this.socket?.readyState === WebSocket.OPEN) {
        const audioEventMessage = {
          headers: { ':message-type': { type: 'string', value: 'event' }, ':event-type': { type: 'string', value: 'AudioEvent' }, ':content-type': { type: 'string', value: 'application/octet-stream' } },
          body: new Uint8Array(pcmBuffer),
        };
        this.socket.send(eventStreamMarshaller.marshall(audioEventMessage));
      }
    });
  }

  downsampleAndEncode = (float32Array) => {
    const inputSampleRate = 44100;
    const outputSampleRate = 16000;
    const ratio = inputSampleRate / outputSampleRate;
    const newLength = Math.round(float32Array.length / ratio);
    const result = new Int16Array(newLength);
    let offsetResult = 0, offsetInput = 0;
    while (offsetResult < result.length) {
      let nextOffsetInput = Math.round((offsetResult + 1) * ratio);
      let accum = 0, count = 0;
      for (let i = offsetInput; i < nextOffsetInput && i < float32Array.length; i++) { accum += float32Array[i]; count++; }
      const s = Math.max(-1, Math.min(1, accum / count));
      result[offsetResult] = s < 0 ? s * 0x8000 : s * 0x7FFF;
      offsetResult++; offsetInput = nextOffsetInput;
    }
    return result.buffer;
  }

  // ==================== BROWSER ====================
  startBrowserRecording = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) { notification.error({ message: 'Browser Speech Recognition not supported. Use Chrome.' }); return; }
    this.browserRecognizer = new SpeechRecognition();
    this.browserRecognizer.continuous = true;
    this.browserRecognizer.interimResults = true;
    this.browserRecognizer.lang = 'en-IN';

    this.browserRecognizer.onresult = (event) => {
      let interimTranscript = '', finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalTranscript += transcript + " ";
        else interimTranscript += transcript;
      }
      if (finalTranscript) {
        const final_raw_result = [...this.state.final_raw_result, finalTranscript.trim()];
        const newFinal = (this.state.smartemrrawdata + " " + finalTranscript).trim();
        this.setState({ text: newFinal, smartemrrawdata: newFinal, final_raw_result, currentPartial: "" });
      } else if (interimTranscript) {
        this.setState({ currentPartial: interimTranscript, text: this.state.smartemrrawdata + " " + interimTranscript });
      }
    };
    this.browserRecognizer.onerror = (event) => console.error("Browser Speech error:", event.error);
    this.browserRecognizer.onend = () => { if (this.state.isRecording && !this.state.isHeld && this.browserRecognizer) this.browserRecognizer.start(); };
    this.browserRecognizer.start();
    this.setState({ isRecording: true, isHeld: false }, () => { this.startWaveformFake(); });
  }

  stopBrowserRecording = () => {
    if (this.browserRecognizer) { this.browserRecognizer.onend = null; this.browserRecognizer.stop(); this.browserRecognizer = null; }
    this.stopWaveformFake();
  }

  // ==================== AZURE ====================
  startAzureRecording = () => {
    speechService.init({ identifier: 'smartemrrawdata', state: true, initialText: this.state.text || '' });
    this.setState({ isRecording: true, isHeld: false }, () => { this.startWaveformFake(); });
  }

  stopAzureRecording = () => {
    speechService.init({ identifier: 'smartemrrawdata', state: false, initialText: this.state.text || '' });
    this.stopWaveformFake();
  }

  // ==================== WAVEFORM ====================
  startWaveform = () => {
    const canvas = this.waveformCanvasRef;
    if (!canvas || !this.analyser) return;
    const ctx = canvas.getContext('2d');
    this.analyser.fftSize = 256;
    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    const draw = () => {
      this.waveformAnimationId = requestAnimationFrame(draw);
      this.analyser.getByteFrequencyData(dataArray);
      const W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      const BAR_COUNT = 60, BAR_GAP = 3;
      const barWidth = Math.floor((W - (BAR_COUNT - 1) * BAR_GAP) / BAR_COUNT);
      const step = Math.floor(bufferLength / BAR_COUNT);
      for (let i = 0; i < BAR_COUNT; i++) {
        let sum = 0;
        for (let j = 0; j < step; j++) sum += dataArray[i * step + j];
        const avg = sum / step;
        const barH = Math.max(4, (avg / 255) * (H - 8));
        const x = i * (barWidth + BAR_GAP), y = (H - barH) / 2;
        ctx.fillStyle = avg > 10 ? '#d24350' : '#f5c6cb';
        ctx.beginPath();
        ctx.roundRect ? ctx.roundRect(x, y, barWidth, barH, barWidth / 2) : ctx.rect(x, y, barWidth, barH);
        ctx.fill();
      }
    };
    draw();
  }

  stopWaveform = () => {
    if (this.waveformAnimationId) { cancelAnimationFrame(this.waveformAnimationId); this.waveformAnimationId = null; }
    if (this.audioContext) { this.audioContext.close(); this.audioContext = null; }
    this.analyser = null;
    const canvas = this.waveformCanvasRef;
    if (canvas) canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
  }

  startWaveformFake = () => {
    this._fakeWaveformInterval = setInterval(() => {
      const canvas = this.waveformCanvasRef;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const w = canvas.width, h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#d24350';
      for (let i = 0; i < 60; i++) {
        const barH = Math.random() * (h * 0.6) + 4;
        const barW = w / 60 - 2;
        ctx.fillRect(i * (barW + 2), (h - barH) / 2, barW, barH);
      }
    }, 100);
  }

  stopWaveformFake = () => {
    clearInterval(this._fakeWaveformInterval);
    const canvas = this.waveformCanvasRef;
    if (canvas) canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
  }

  // ==================== HOLD / RESUME / STOP ====================
  holdStreaming = () => {
    const method = this.getSmartEmrVoiceMethod();
    // Commit partial
    if (this.state.currentPartial && this.state.currentPartial.trim() !== '') {
      const committed = (this.state.smartemrrawdata + " " + this.state.currentPartial).trim();
      this.setState({ smartemrrawdata: committed, text: committed, final_raw_result: [...this.state.final_raw_result, this.state.currentPartial.trim()], currentPartial: "" });
    }
    if (method === 'browser') { this.stopBrowserRecording(); }
    else if (method === 'azure') { this.stopAzureRecording(); }
    else { this.stopWaveform(); this.micStream?.stop(); this.socket?.close(); }
    this.pauseAudioRecording();
    this.setState({ isRecording: false, isHeld: true });
  }

  resumeStreaming = async () => {
    this.setState({ isHeld: false });
    await this.startStreaming(true);
  }

  stopStreaming = async () => {
    const method = this.getSmartEmrVoiceMethod();
    if (method === 'browser') { this.stopBrowserRecording(); }
    else if (method === 'azure') { this.stopAzureRecording(); }
    else { this.stopWaveform(); this.micStream?.stop(); this.socket?.close(); }
    // Finalize the audio recording into a blob
    this.recordedBlob = await this.stopAudioRecording();
    this.setState({ isRecording: false, isHeld: false, smartemr_field_disabled: true, isSummarizing: true, recordingDone: true });

    // Commit any pending partial before checking if anything was recorded
    let committedRaw = this.state.smartemrrawdata;
    let committedFinal = this.state.final_raw_result;
    if (this.state.currentPartial && this.state.currentPartial.trim() !== '') {
      const corrected = await this.textCorrection(this.state.currentPartial, this.state.correction_terms);
      committedRaw = ((this.state.smartemrrawdata || '') + " " + corrected).trim();
      committedFinal = [...this.state.final_raw_result, corrected];
      this.setState({ smartemrrawdata: committedRaw, text: committedRaw, final_raw_result: committedFinal, currentPartial: "" });
    }

    // Nothing recorded — don't open the result modal, just alert the user
    if ((committedRaw || '').trim() === '') {
      this.setState({ isRecording: false, isHeld: false, isSummarizing: false, recordingDone: false, smartemr_field_disabled: false });
      smartEmrRecordingService.reset();
      Modal.warning({
        title: 'MySmart EMR',
        content: 'Nothing is recorded to process MySmart EMR.',
        centered: true,
        zIndex: 10001,
      });
      return;
    }

    this.setState({ isRecording: false, isHeld: false, smartemr_field_disabled: true, isSummarizing: true, recordingDone: true });

    // Summarize
    const payload = { reference_id: LS_SERVICE.get('reference_id'), reference_type: LS_SERVICE.get('reference_type'), staff_id: LS_SERVICE.get('staff_id'), data: this.state.text };
    try {
      const response = await API_SERVICE.post(DATA_SUMMARIZE, payload);
      this.setState({ smartemrrawdata: response?.summarize || this.state.text, text: response?.summarize || this.state.text, isSummarizing: false });
    } catch (err) {
      console.error("Summarize failed:", err);
      this.setState({ isSummarizing: false });
    }
  }

  textCorrection = async (transcript, correction_terms) => {
    if (!correction_terms || correction_terms.length === 0) return transcript;
    const sortedTerms = [...correction_terms].sort((a, b) => b.original_text.length - a.original_text.length);
    let corrected = transcript;
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    sortedTerms.forEach(term => {
      const isHindi = /[\u0900-\u097F]/.test(term.original_text);
      const safeText = escapeRegExp(term.original_text);
      const pattern = isHindi ? new RegExp(safeText, 'g') : new RegExp(`\\b${safeText}\\b`, 'gi');
      corrected = corrected.replace(pattern, term.corrected_text);
    });
    return corrected;
  }

  // ==================== AUDIO UPLOAD ====================
  uploadAudio = async (referenceId, smartEmrDataId) => {
    if (!this.recordedBlob) return;
    const ext = (this.recordedBlob.type.includes('webm')) ? 'webm' : 'audio';
    const formData = new FormData();
    // Text fields MUST come before the file so the backend parser reads them first
    formData.append('reference_id', referenceId);
    formData.append('reference_type', LS_SERVICE.get('reference_type'));
    formData.append('client_ref', this.clientRef || ''); // correlates this audio with its process entry
    formData.append('smart_emr_data_id', smartEmrDataId || ''); // the entry this recording belongs to (if known)
    formData.append('staff_id', LS_SERVICE.get('staff_id'));
    formData.append('enterprise_id', LS_SERVICE.get('ENTERPRISE_ID'));
    formData.append('store_id', LS_SERVICE.get('STORE_ID'));
    formData.append('audio', this.recordedBlob, `smartemr_${referenceId}.${ext}`); // file LAST
    await axios.post(SMART_EMR_AUDIO_UPLOAD, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  // ==================== PROCESS DATA ====================
  saveSmartEmrRawData = async () => {
    if (this.state.isRecording) { await this.stopStreaming(); }

    // Nothing recorded — block processing and alert the user
    const recordedText = (this.state.smartemrrawdata || this.state.text || '').trim();
    if (recordedText === '') {
      Modal.warning({
        title: 'MySmart EMR',
        content: 'Nothing is recorded to process MySmart EMR.',
        centered: true,
        zIndex: 10001,
      });
      return;
    }

    const patientInfo = this.state.patientInfo;
    const referenceId = patientInfo?.qms_token_id || LS_SERVICE.get('reference_id');
    const payload = {
      reference_id: referenceId,
      reference_type: LS_SERVICE.get('reference_type'),
      staff_id: LS_SERVICE.get('staff_id'),
      enterprise_id: LS_SERVICE.get('ENTERPRISE_ID'),
      store_id: LS_SERVICE.get("STORE_ID"),
      data: this.state.smartemrrawdata,
      data_raw: this.state.final_raw_result,
      client_ref: this.clientRef
    };
    this.setState({ smartemr_loader: true });
    try {
      // 1. Process & store the smart EMR data first so the entry exists
      const response = await API_SERVICE.post(PROCESS_AND_STORE_SMART_EMR, payload);

      // 2. Upload the audio linked to the newly created entry (non-blocking)
      const smartEmrDataId = response?.smart_emr_data_id || response?.data_id || response?.processed_data?.id || null;
      try {
        await this.uploadAudio(referenceId, smartEmrDataId);
      } catch (audioErr) {
        console.error('Audio upload failed:', audioErr?.message);
      }

      this.setState({ smartemr_loader: false });
      if (response.success === true) {
        this.setState({ smartemrmodal: false, smartemrMinimized: false, recordingDone: false, isSummarizing: false });
        smartEmrRecordingService.reset();
        notification.success({ message: 'Smart EMR data processed successfully.' });

        const hospitalId = LS_SERVICE.get('slot_hospital_id') || LS_SERVICE.get('FACILITY_ID');
        const patientId = patientInfo?.patient_id;
        const referenceType = LS_SERVICE.get('reference_type') || 0;
        const referenceId = patientInfo?.qms_token_id || LS_SERVICE.get('reference_id');
        const targetPath = `/patient/soapss/${hospitalId}/${patientId}/${referenceType}/${referenceId}`;

        // Broadcast processed signal so an already-mounted soap page can reload in place
        smartEmrRecordingService.update({ processedComplete: Date.now(), processedData: response.processed_data });

        if (patientId && referenceId) {
          if (this.props.location.pathname === targetPath) {
            // Already on the SOAP page — no navigation, the page reloads via the processedComplete signal
          } else {
            this.props.history.push(targetPath);
          }
        }
      } else {
        notification.error({ message: response?.message || 'Failed to process Smart EMR data.' });
      }
    } catch (err) {
      this.setState({ smartemr_loader: false });
      console.error("Process data failed:", err);
      notification.error({ message: 'Failed to process Smart EMR data.' });
    }
  }

  handleOnChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, text: e.target.value });
  }

  render() {
    const { isRecording, isHeld, isSummarizing, recordingDone, recordingSeconds } = this.state;
    const isActive = isRecording || isHeld || isSummarizing;
    const showFloatingBar = isRecording || isHeld;
    const showResultModal = isSummarizing || recordingDone;

    return (
      <>
        {/* Navigation Block Modal */}
        <Modal
          visible={this.state.navBlockVisible}
          closable={false}
          footer={null}
          centered
          width={420}
          zIndex={10000}
          bodyStyle={{ textAlign: 'center', padding: '32px 24px' }}
        >
          <div style={{ marginBottom: 16 }}>
            <span style={{ fontSize: 40 }}>🎙️</span>
          </div>
          <h5 style={{ fontWeight: 600, marginBottom: 12 }}>MySmart EMR in Progress</h5>
          <p style={{ color: '#666', marginBottom: 24 }}>
            You cannot exit a patient page while filling MySmart EMR.
          </p>
          <Button
            type="primary"
            className="btn btn-primary px-5"
            onClick={() => this.setState({ navBlockVisible: false })}
          >
            CLOSE
          </Button>
        </Modal>

        {/* Sticky Top Recording Bar (slides in/out via CSS transition) */}
        <>
          <style>{`
            @keyframes waveform-pulse { 0% { box-shadow: 0 0 0 0 rgba(255,255,255,0.7); } 70% { box-shadow: 0 0 0 8px rgba(255,255,255,0); } 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0); } }
          `}</style>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: '50%',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '8px 18px',
              width: 420,
              boxSizing: 'border-box',
              background: '#d24350',
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              border: '2px solid #d24350',
              borderTop: 'none',
              userSelect: 'none',
              transform: showFloatingBar ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-110%)',
              opacity: showFloatingBar ? 1 : 0,
              transition: 'transform 0.6s ease, opacity 0.6s ease',
              pointerEvents: showFloatingBar ? 'auto' : 'none',
            }}
          >
            {/* Pulsing dot or paused indicator */}
            <span style={{
              width: 12, height: 12, borderRadius: '50%',
              background: '#fff',
              animation: isRecording ? 'waveform-pulse 1.2s infinite' : 'none',
              flexShrink: 0
            }} />

            {/* Status (fixed width so text change doesn't shift layout) */}
            <span style={{ fontSize: 14, fontWeight: 600, color: '#fff', width: 80, flexShrink: 0 }}>
              {isRecording ? 'Recording' : 'On Hold'}
            </span>
            {/* Timer (fixed width) */}
            <span style={{ fontSize: 14, color: '#fff', width: 44, flexShrink: 0, fontWeight: 600 }}>
              {`${String(Math.floor(recordingSeconds / 60)).padStart(2, '0')}:${String(recordingSeconds % 60).padStart(2, '0')}`}
            </span>

            {/* Action Buttons (fixed-width container, pushed to the right) */}
            <div style={{ display: 'flex', gap: 8, marginLeft: 'auto', flexShrink: 0 }}>
              {isRecording && (
                <Button size="small" style={{ borderRadius: 16, fontSize: 12, fontWeight: 600, width: 82 }} onClick={this.holdStreaming}>⏸ Hold</Button>
              )}
              {isHeld && (
                <Button size="small" style={{ borderRadius: 16, fontSize: 12, fontWeight: 600, width: 82 }} onClick={this.resumeStreaming}>▶️ Resume</Button>
              )}
              <Button size="small" style={{ borderRadius: 16, fontSize: 12, fontWeight: 600, width: 72 }} onClick={this.stopStreaming}>⏹️ Stop</Button>
            </div>
          </div>
        </>

        {/* Result Modal (Processing + Textarea + Process Data) */}
        <Modal
          destroyOnClose={false}
          title="MySmart EMR"
          visible={showResultModal}
          footer={false}
          width={800}
          closable={!isSummarizing}
          maskClosable={false}
          onCancel={() => {
            if (!isSummarizing) {
              this.setState({ recordingDone: false, isSummarizing: false });
              smartEmrRecordingService.reset();
            }
          }}
        >
          {/* SUMMARIZING */}
          {isSummarizing && (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              {LOADER_RED}
              <p style={{ marginTop: 12, color: '#555' }}>Processing your recording…</p>
            </div>
          )}

          {/* DONE — editable textarea + Process button */}
          {!isSummarizing && recordingDone && (
            <div>
              <div className='form-group hasdata'>
                <textarea
                  className="form-control subjective-field show-placeholder"
                  id="smartemrrawdata"
                  value={this.state.text}
                  name="smartemrrawdata"
                  onChange={this.handleOnChange}
                  rows="10"
                />
              </div>
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                <Button
                  type="primary"
                  className="btn btn-primary px-5"
                  style={{ borderRadius: 24, height: 44, fontSize: 15 }}
                  onClick={this.saveSmartEmrRawData}
                  loading={this.state.smartemr_loader}
                >
                  PROCESS DATA
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </>
    );
  }
}

export default withRouter(SmartEmrRecorder);
